var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudSyncAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4C5.46243 4 3 6.46243 3 9.5C3 10.4168 3.22431 11.2812 3.62104 12.0413C2.63045 12.8668 2 14.1098 2 15.5C2 17.9853 4.01472 20 6.5 20H17.5C19.9853 20 22 17.9853 22 15.5C22 13.9124 21.1779 12.5168 19.9361 11.7158C19.9781 11.4836 20 11.2443 20 11C20 8.79086 18.2091 7 16 7C15.1467 7 14.3558 7.26719 13.7064 7.72247C12.9674 5.55718 10.9155 4 8.5 4ZM11.353 12.9428C11.6608 13.22 11.6855 13.6942 11.4083 14.002L10.0571 15.502C9.9194 15.6548 9.72499 15.7444 9.51936 15.7497C9.31372 15.7551 9.11492 15.6758 8.96947 15.5303L7.46964 14.0303C7.17676 13.7374 7.17679 13.2625 7.4697 12.9696C7.76261 12.6768 8.23748 12.6768 8.53036 12.9697L8.70015 13.1395C9.08882 11.4829 10.5753 10.25 12.3511 10.25C14.423 10.25 16.1011 11.9284 16.1011 14C16.1011 16.0716 14.423 17.75 12.3511 17.75C11.9369 17.75 11.6011 17.4142 11.6011 17C11.6011 16.5858 11.9369 16.25 12.3511 16.25C13.5946 16.25 14.6011 15.2433 14.6011 14C14.6011 12.7567 13.5946 11.75 12.3511 11.75C11.4997 11.75 10.7595 12.2219 10.3772 12.9185C10.659 12.6883 11.0743 12.6917 11.353 12.9428Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudSyncAlt);
export default __webpack_public_path__ + "static/media/cloud-sync-alt.0f4a0e41e087586f552b27a32ed22ace.svg";
export { ForwardRef as ReactComponent };